import Head from 'next/head';
import _get from 'lodash/get';
import dynamic from 'next/dynamic';

import Layout from '@/layouts/user';

import About from '@/components/home/About';
import Blog from '@/components/home/Blog';
import Cats from '@/components/home/Cats';
import Contest from '@/components/home/Contest';

import { getCategories, getProducts, getBlogs } from '@/API/public';

export const Carousel = dynamic(() => import('@/components/home/Carousel'), {
  ssr: false,
});

const parseProData = (arr = []) =>
  arr.map((i) => ({
    id: i.id,
    name: i.name,
    img: _get(i, 'image.url', null),
    // rial to tooman
    final_price: parseInt(_get(i, 'price.final_price', 0) / 10),
    base_price: parseInt(_get(i, 'price.base_price', 0) / 10),
    discount: Boolean(_get(i, 'price.dicount_percentage', 0)),
  }));

const parseBlogData = (arr = []) =>
  arr.map((i) => ({
    id: i.id,
    link: i.link,
    title: _get(i, 'title.rendered', ''),
    des: _get(i, 'excerpt.rendered', ''),
    img: _get(i, '_embedded[wp:featuredmedia][0].source_url', null),
    cat: _get(i, '_embedded[wp:term][0][0].name', ''),
  }));

export default function Index({ proList, CatList, blogList }) {
  return (
    <Layout CategoryData={CatList}>
      <Head>
        <link rel="preconnect" href="https://www.aparat.com" crossOrigin />
        <link rel="dns-prefetch" href="https://www.aparat.com" />
      </Head>
      <Contest />
      <Carousel DATA={proList} />
      <About />
      <Cats CatList={CatList} />
      <Blog DATA={blogList} />
    </Layout>
  );
}

export async function getStaticProps() {
  const CatList = await getCategories();
  const proList = await getProducts();
  const blogList = await getBlogs();

  return {
    props: {
      proList: parseProData(proList),
      CatList,
      blogList: parseBlogData(blogList),
    }, // will be passed to the page component as props
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    revalidate: 30 * 60, // In seconds
  };
}
